// DO NOT EDIT -- generated from fs/services/dx-objects/home.proto

import { FunnelDetail } from './funnels.proto';
import { HeatmapDetail } from './heatmaps.proto';
import { MetricDetail } from './metrics.proto';
import { RetentionMetricDetail } from './retentionmetrics.proto';
import { SegmentDetail } from './segments.proto';
import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';

export namespace HomeInternal {

  export const GetHomeEndpoint = "/grpc/dx_objects.HomeInternal/GetHome";
  export function GetHome(sender: (req: GetHomeRequest, endpoint: string) => Promise<Home>, req: GetHomeRequest): { promise: () => Promise<Home>, endpoint: string } {
    return {
      promise: () => sender(req, GetHomeEndpoint),
      endpoint: GetHomeEndpoint
    };
  }
}

export namespace HomePublic {

  export const GetHomeEndpoint = "/grpc/dx_objects.HomePublic/GetHome";
  export function GetHome(sender: (req: GetHomeRequest, endpoint: string) => Promise<Home>, req: GetHomeRequest): { promise: () => Promise<Home>, endpoint: string } {
    return {
      promise: () => sender(req, GetHomeEndpoint),
      endpoint: GetHomeEndpoint
    };
  }

  export const SetHomeEndpoint = "/grpc/dx_objects.HomePublic/SetHome";
  export function SetHome(sender: (req: SetHomeRequest, endpoint: string) => Promise<Home>, req: SetHomeRequest): { promise: () => Promise<Home>, endpoint: string } {
    return {
      promise: () => sender(req, SetHomeEndpoint),
      endpoint: SetHomeEndpoint
    };
  }

  export const CreateHomeSectionEndpoint = "/grpc/dx_objects.HomePublic/CreateHomeSection";
  export function CreateHomeSection(sender: (req: CreateHomeSectionRequest, endpoint: string) => Promise<Home>, req: CreateHomeSectionRequest): { promise: () => Promise<Home>, endpoint: string } {
    return {
      promise: () => sender(req, CreateHomeSectionEndpoint),
      endpoint: CreateHomeSectionEndpoint
    };
  }

  export const SetHomeSectionEndpoint = "/grpc/dx_objects.HomePublic/SetHomeSection";
  export function SetHomeSection(sender: (req: SetHomeSectionRequest, endpoint: string) => Promise<Home>, req: SetHomeSectionRequest): { promise: () => Promise<Home>, endpoint: string } {
    return {
      promise: () => sender(req, SetHomeSectionEndpoint),
      endpoint: SetHomeSectionEndpoint
    };
  }

  export const DuplicateHomeCardEndpoint = "/grpc/dx_objects.HomePublic/DuplicateHomeCard";
  export function DuplicateHomeCard(sender: (req: DuplicateHomeCardRequest, endpoint: string) => Promise<DuplicateHomeCardResponse>, req: DuplicateHomeCardRequest): { promise: () => Promise<DuplicateHomeCardResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DuplicateHomeCardEndpoint),
      endpoint: DuplicateHomeCardEndpoint
    };
  }

  export const SetSectionOrderEndpoint = "/grpc/dx_objects.HomePublic/SetSectionOrder";
  export function SetSectionOrder(sender: (req: SetSectionOrderRequest, endpoint: string) => Promise<Home>, req: SetSectionOrderRequest): { promise: () => Promise<Home>, endpoint: string } {
    return {
      promise: () => sender(req, SetSectionOrderEndpoint),
      endpoint: SetSectionOrderEndpoint
    };
  }

  export const DeleteHomeSectionEndpoint = "/grpc/dx_objects.HomePublic/DeleteHomeSection";
  export function DeleteHomeSection(sender: (req: DeleteHomeSectionRequest, endpoint: string) => Promise<Home>, req: DeleteHomeSectionRequest): { promise: () => Promise<Home>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteHomeSectionEndpoint),
      endpoint: DeleteHomeSectionEndpoint
    };
  }

  export const SetHomeCardEndpoint = "/grpc/dx_objects.HomePublic/SetHomeCard";
  export function SetHomeCard(sender: (req: SetHomeCardRequest, endpoint: string) => Promise<Home>, req: SetHomeCardRequest): { promise: () => Promise<Home>, endpoint: string } {
    return {
      promise: () => sender(req, SetHomeCardEndpoint),
      endpoint: SetHomeCardEndpoint
    };
  }

  export const DeleteHomeCardEndpoint = "/grpc/dx_objects.HomePublic/DeleteHomeCard";
  export function DeleteHomeCard(sender: (req: DeleteHomeCardRequest, endpoint: string) => Promise<Home>, req: DeleteHomeCardRequest): { promise: () => Promise<Home>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteHomeCardEndpoint),
      endpoint: DeleteHomeCardEndpoint
    };
  }

  export const ResetHomeEndpoint = "/grpc/dx_objects.HomePublic/ResetHome";
  /**
   * ResetHome resets the users' Home experience to be empty,
   * or to the predefined zero state if flag app-home-zero-state is enabled.
   */
  export function ResetHome(sender: (req: ResetHomeRequest, endpoint: string) => Promise<{}>, req: ResetHomeRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, ResetHomeEndpoint),
      endpoint: ResetHomeEndpoint
    };
  }
}

export interface Home {
  sections: HomeSection[];
}

export interface HomeSection {
  id: string;
  name: string;
  cards: HomeCard[];
}

export interface HomeCard {
  id: string;
  metricId?: string;
  funnelId?: string;
  heatmapId?: string;
  journeyId?: string;
  segmentId?: string;
  retentionId?: string;
  dashboardId?: protobuf.int64;
  textCard?: boolean;
  format: HomeCard.Format;
  funnelMetricType: HomeCard.FunnelMetricType;
  chartType: HomeCard.ChartType;
  markdown: string;
}

export namespace HomeCard {
  export enum library_object {
    metricId = 2,
    funnelId = 3,
    heatmapId = 10,
    journeyId = 11,
    segmentId = 4,
    retentionId = 8,
    dashboardId = 9,
    textCard = 12
  }

  export function library_object_oneof(m: HomeCard): { opt: library_object.dashboardId, val: protobuf.int64 } | { opt: library_object.funnelId, val: string } | { opt: library_object.heatmapId, val: string } | { opt: library_object.journeyId, val: string } | { opt: library_object.metricId, val: string } | { opt: library_object.retentionId, val: string } | { opt: library_object.segmentId, val: string } | { opt: library_object.textCard, val: boolean } | null {
    if (m.metricId != null) { return { opt: library_object.metricId, val: m.metricId } }
    if (m.funnelId != null) { return { opt: library_object.funnelId, val: m.funnelId } }
    if (m.heatmapId != null) { return { opt: library_object.heatmapId, val: m.heatmapId } }
    if (m.journeyId != null) { return { opt: library_object.journeyId, val: m.journeyId } }
    if (m.segmentId != null) { return { opt: library_object.segmentId, val: m.segmentId } }
    if (m.retentionId != null) { return { opt: library_object.retentionId, val: m.retentionId } }
    if (m.dashboardId != null) { return { opt: library_object.dashboardId, val: m.dashboardId } }
    if (m.textCard != null) { return { opt: library_object.textCard, val: m.textCard } }
    return null;
  }

  export enum Format {
    FORMAT_INVALID = 0,
    FORMAT_SMALL = 1,
    FORMAT_MEDIUM = 2,
    FORMAT_LARGE = 3,
    /** @deprecated */
    FORMAT_PLAYLIST = 4
  }

  export enum FunnelMetricType {
    FUNNEL_METRIC_TYPE_INVALID = 0,
    FUNNEL_METRIC_TYPE_USER_COUNT = 1,
    FUNNEL_METRIC_TYPE_CONVERSION_RATE = 2,
    FUNNEL_METRIC_TYPE_TIME_TO_COMPLETE = 3
  }

  export enum ChartType {
    CHART_TYPE_INVALID = 0,
    CHART_TYPE_LINE_CHART = 1,
    CHART_TYPE_BAR_CHART = 2,
    CHART_TYPE_SINGLE_NUMBER = 3,
    CHART_TYPE_PLAYLIST = 4,
    CHART_TYPE_NAME = 5,
    CHART_TYPE_TEXT = 6,
    CHART_TYPE_HEATMAP = 7
  }
}

export interface DuplicateHomeCardResponse {
  home: Home | null;
  segment?: SegmentDetail | null;
  metric?: MetricDetail | null;
  funnel?: FunnelDetail | null;
  retention?: RetentionMetricDetail | null;
  heatmap?: HeatmapDetail | null;
}

export namespace DuplicateHomeCardResponse {
  export enum created {
    segment = 2,
    metric = 3,
    funnel = 4,
    retention = 5,
    heatmap = 6
  }

  export function created_oneof(m: DuplicateHomeCardResponse): { opt: created.funnel, val: FunnelDetail } | { opt: created.heatmap, val: HeatmapDetail } | { opt: created.metric, val: MetricDetail } | { opt: created.retention, val: RetentionMetricDetail } | { opt: created.segment, val: SegmentDetail } | null {
    if (m.segment != null) { return { opt: created.segment, val: m.segment } }
    if (m.metric != null) { return { opt: created.metric, val: m.metric } }
    if (m.funnel != null) { return { opt: created.funnel, val: m.funnel } }
    if (m.retention != null) { return { opt: created.retention, val: m.retention } }
    if (m.heatmap != null) { return { opt: created.heatmap, val: m.heatmap } }
    return null;
  }
}

export interface GetHomeRequest {
  orgId: string;
}

export interface SetHomeRequest {
  orgId: string;
  home: Home | null;
}

export interface SetHomeSectionRequest {
  orgId: string;
  section: HomeSection | null;
}

export interface CreateHomeSectionRequest {
  section: HomeSection | null;
  /** insert_at = nil or out of bounds appends a new card at the end */
  insertAt: protobuf.int64 | null;
  orgId: string;
}

export interface DeleteHomeSectionRequest {
  orgId: string;
  homeSectionId: string;
}

export interface SetHomeCardRequest {
  homeSectionId: string;
  /**
   * if the id field is not set, an id will be generated and a new card will be
   * stored
   */
  homeCard: HomeCard | null;
  orgId: string;
}

export interface DuplicateHomeCardRequest {
  orgId: string;
  homeCardId: string;
  homeSectionId: string;
  visibility: protoauditstore.Visibility;
}

export interface DeleteHomeCardRequest {
  homeSectionId: string;
  homeCardId: string;
  orgId: string;
}

export interface SetSectionOrderRequest {
  homeSectionIds: string[];
  orgId: string;
}

export interface ResetHomeRequest {
  orgId: string;
  seatEmails: string[];
}
